import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { EquisUtilsModule } from '@tn-equis/core/utils';

class EquisTagComponent {
    constructor() {
        this.typeColor = 'success';
    }
    set type(type) {
        const types = {
            info: 'info',
            warning: 'warning',
            error: 'error',
            success: 'success',
            default: 'neutral',
        };
        this.typeColor = types[type] || types['default'];
    }
    typeClass() {
        return `equis-tag--${this.typeColor}`;
    }
}
EquisTagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisTagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisTagComponent, selector: "z-tag, equis-tag", inputs: { text: "text", type: "type" }, ngImport: i0, template: "<div class=\"equis-tag\" [ngClass]=\"[typeClass()]\">\n  <span class=\"equis-caption equis-tag__text\">{{ text }}</span>\n</div>\n", styles: [":host{display:flex;justify-content:center;width:100%}:host .equis-tag{align-items:center;border-radius:6px;cursor:default;display:inline-flex;height:20px;justify-content:center;padding:2px 4px}:host .equis-tag__text{color:inherit}:host .equis-tag--error{background:#fbe9e9;color:#ba1a1a}:host .equis-tag--warning{background:#fcf0ce;color:#996b09}:host .equis-tag--success{background:#e4f3e7;color:#19722c}:host .equis-tag--info{background:#e6eefa;color:#0d4ca6}:host .equis-tag--neutral{background:#e8e8e8;color:#767676}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTagComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-tag, equis-tag', template: "<div class=\"equis-tag\" [ngClass]=\"[typeClass()]\">\n  <span class=\"equis-caption equis-tag__text\">{{ text }}</span>\n</div>\n", styles: [":host{display:flex;justify-content:center;width:100%}:host .equis-tag{align-items:center;border-radius:6px;cursor:default;display:inline-flex;height:20px;justify-content:center;padding:2px 4px}:host .equis-tag__text{color:inherit}:host .equis-tag--error{background:#fbe9e9;color:#ba1a1a}:host .equis-tag--warning{background:#fcf0ce;color:#996b09}:host .equis-tag--success{background:#e4f3e7;color:#19722c}:host .equis-tag--info{background:#e6eefa;color:#0d4ca6}:host .equis-tag--neutral{background:#e8e8e8;color:#767676}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { text: [{
                type: Input
            }], type: [{
                type: Input
            }] } });

class EquisTagModule {
    constructor() { }
    static forRoot() {
        return {
            ngModule: EquisTagModule,
        };
    }
}
EquisTagModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisTagModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisTagModule, declarations: [EquisTagComponent], imports: [CommonModule, EquisUtilsModule], exports: [EquisTagComponent] });
EquisTagModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTagModule, imports: [CommonModule, EquisUtilsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisTagModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisTagComponent],
                    imports: [CommonModule, EquisUtilsModule],
                    exports: [EquisTagComponent],
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of equis-tag
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisTagComponent, EquisTagModule };
